function escapeHtml(unsafe: string): string {
  return unsafe
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

export function replaceMarkdown(inputString: string): string {
  try {
    const codeBlocks: { [key: string]: string } = {};
    let blockCounter = 0;

    // Extract code blocks with placeholders
    inputString = inputString.replace(
      /```(\w*)?\n?([^`]+)```/g,
      function (_match, p1, p2) {
        const placeholder = `<!--codeblock${blockCounter}-->`;
        codeBlocks[placeholder] = `<pre><code class="${p1 || ""}">${escapeHtml(
          p2.trim()
        )}</code></pre>`;
        blockCounter++;
        return placeholder;
      }
    );

    // Markdown links
    inputString = inputString.replace(
      /\[([^\]]+)\]\(((https?|mailto|gleap):\/\/[^\)]+)\)/g,
      '<a href="$2" target="_blank">$1</a>'
    );

    // Bold
    inputString = inputString.replace(
      /(\*\*|__)(.*?)\1/g,
      "<strong>$2</strong>"
    );

    // Italic
    inputString = inputString.replace(/(\*|_)(.*?)\1/g, "<em>$2</em>");

    // Inline code
    inputString = inputString.replace(/`([^`]+)`/g, function (_match, p1) {
      return `<code>${escapeHtml(p1)}</code>`;
    });

    // Restore code blocks
    Object.keys(codeBlocks).forEach((placeholder) => {
      inputString = inputString.replace(placeholder, codeBlocks[placeholder]);
    });

    // AI annotation tooltips [^1|title|url]
    inputString = inputString.replace(
      /\[\^(\d+)\|([^|]+)\|([^\]]+)\]/g,
      `<a href="$3" target="_blank" class="ai-annotation" data-title="$2">$1</a>`
    );

    return inputString;
  } catch (e) {
    console.error(e);
    return inputString;
  }
}
